const navMenu = document.querySelector(".icons-container");
const activeLinks = document.querySelectorAll(
	".nav-slider .swiper-wrapper .swiper-slide a"
);
const category = document.querySelector(".cat");
const categoryContainer = document.querySelector(".categories-container");
const catClose = document.querySelector(".cat-close");

category.addEventListener("touchstart", () => {
	categoryContainer.classList.add("show");
});

window.addEventListener("click", (e) => {
	if (!categoryContainer.contains(e.target)) {
		categoryContainer.classList.remove("show");
	}
});

let lastScrollTop = 0;

window.addEventListener("scroll", () => {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	if (scrollTop > lastScrollTop) {
		navMenu.classList.add("hide");
	} else {
		navMenu.classList.remove("hide");
	}
	lastScrollTop = scrollTop;
});

function activeLink() {
	activeLinks.forEach((link) => link.classList.remove("active"));
	this.classList.add("active");
}

activeLinks.forEach((link) => link.addEventListener("click", activeLink));

// login and register form
// const navLoginBtn = document.querySelector(".login > span:last-child");

// const navLoginBtn = document.querySelector(".login");
// const loginRegisterContainer = document.querySelector(
// 	".login-register-form-overlay"
// );
// const loginRegisterClsBtn = document.querySelector(
// 	".login-register-form-cls-btn"
// );

// const loginBtn = document.querySelector(".register-form-footer-text > span");
// const registerBtn = document.querySelector(".login-form-footer-text > span");

// navLoginBtn.addEventListener("click", () => {
// 	loginRegisterContainer.classList.add("active");
// });

// loginRegisterClsBtn.addEventListener("click", () => {
// 	loginRegisterContainer.classList.remove("active");
// });

// // render each form at one time
// registerBtn.addEventListener("click", () => {
// 	document.querySelector(".login-form").style.display = "none";
// 	document.querySelector(".register-form").style.display = "block"
// })

// loginBtn.addEventListener("click", () => {
// 	document.querySelector(".login-form").style.display = "block";
// 	document.querySelector(".register-form").style.display = "none"
// })

// function startCartAnimation() {
// 	const cartContainer = document.querySelector(".cart-anim-container");

// 	function animateCart() {
// 		// Reset cart position and make it visible
// 		cartContainer.style.display = "block";
// 		cartContainer.style.opacity = "0";
// 		cartContainer.style.transform = "translateX(-100%)";

// 		// Add animations
// 		cartContainer.style.animation = "cartAnim 0.9s ease-in-out forwards";

// 		// Add shake animation to badge AFTER cart animation completes
// 		const badge = cartContainer.querySelector("span");

// 		// First, remove any existing animation
// 		badge.style.animation = "none";

// 		// Force a reflow
// 		badge.offsetHeight;

// 		// Add shake animation after cart animation completes
// 		cartContainer.addEventListener(
// 			"animationend",
// 			function shakeAfterCart() {
// 				badge.style.animation =
// 					"shakeAnimation 0.82s cubic-bezier(.36,.07,.19,.97) both";
// 				// Remove the event listener to prevent multiple animations
// 				cartContainer.removeEventListener(
// 					"animationend",
// 					shakeAfterCart
// 				);
// 			},
// 			{ once: true }
// 		);

// 		// Hide cart after 5 seconds
// 		setTimeout(() => {
// 			cartContainer.style.animation =
// 				"cartDisappear 0.5s ease-in-out forwards";
// 		}, 6700);

// 		// Clean up animations
// 		setTimeout(() => {
// 			cartContainer.style.display = "none";
// 		}, 7200);
// 	}

// 	// Initial animation
// 	animateCart();

// 	// Repeat every 10 seconds
// 	setInterval(animateCart, 20000);
// }

// // Start the animation sequence
// startCartAnimation();
